import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const FamilyFestGetVehiclesByPickupId = (request) => {
    return vdkEmHappinessPortalApi.post('familyfest/pickup-locations/vehicles/get-all', request);
};
const FamilyFestCreateVehicle = (request) => {
    return vdkEmHappinessPortalApi.post(`/family-fest/pickup-locations/${request.pickupLocationId}/vehicles`, request);
};
const FamilyFestUpdateVehicle = (request) => {
    return vdkEmHappinessPortalApi.put(`/family-fest/vehicles/${request.id}`, request);
};
const FamilyFestDeleteVehicle = (id) => {
    return vdkEmHappinessPortalApi.delete(`/family-fest/vehicles/${id}`);
};
const FamilyFestGetVehiclesPaginated = (request) => {
    return vdkEmHappinessPortalApi.post('/family-fest/pickup-locations/get-all/vehicles', request);
};
const FamilyFestGetVehicleById = (id) => {
    return vdkEmHappinessPortalApi.get(`/family-fest/vehicles/${id}`);
};
const getFamilyFestRouteVehiclesByPickupLocation = (pickupLocationId) => {
    return vdkEmHappinessPortalApi.get(`/family-fest/pickup-locations/${pickupLocationId}/route-vehicles`);
};
const familyFestPickupLocationVehicleAPI = {
    FamilyFestGetVehiclesByPickupId,
    FamilyFestCreateVehicle,
    FamilyFestUpdateVehicle,
    FamilyFestDeleteVehicle,
    FamilyFestGetVehiclesPaginated,
    FamilyFestGetVehicleById,
    getFamilyFestRouteVehiclesByPickupLocation
};
export default familyFestPickupLocationVehicleAPI;
